import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {CREATE_NEW_CYCLE_ERROR, CREATE_NEW_CYCLE_START, CREATE_NEW_CYCLE_SUCCESS} from "../../types";

export function* create({payload}) {
  try {
    const url = '/news_cycle/';
    const method = 'POST';
    const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
    const data = (object) => Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());
    const results = yield call(apiCall, url, method, data(payload.formData), headers);
    yield put({type: CREATE_NEW_CYCLE_SUCCESS, results: results.data});
    yield put(payload.navigate('/app/content-management/manage-cycle'));
  } catch (error) {
    yield put({type: CREATE_NEW_CYCLE_ERROR, error});
  }
}

export default function* create_new_cycle() {
  yield takeLatest(CREATE_NEW_CYCLE_START, create);
}
